import { useTranslation } from "react-i18next";
import css from "./page-action-configuration.scss";
import React from "react";
import { ReactFlowProvider } from "@xyflow/react";
import { ActionConfiguration } from "../ui/atoms/action-configuration";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

export function PageActionConfiguration(): JSX.Element {
    const { t } = useTranslation();

    return (
        <FusionLayout
            fullWidth
            suggestedHelpArticles={[
                articles.actionConfigsCreating,
                articles.actionConfigsModifying,
                articles.actionConfigsImportingAndInterconnectingNodes,
                articles.actionConfigsInputNodesDescription,
                articles.actionConfigsIntermediateNodesDescription,
                articles.actionConfigsGoDriveZoneFunctionDescriptions,
                articles.actionConfigsExampleTemplateZoneConfiguration,
                articles.actionConfigsSpeedFunctionDescription,
                articles.actionConfigsGuestFunctionDescription,
                articles.actionConfigsAccessFunctionDescription,
                articles.actionConfigsSafeZoneFunctionDescription,
                articles.actionConfigsCrossWalkFunctionDescription,
                articles.actionConfigsCounterPlusFunctionDescription,
            ]}
            breadcrumb={t("page.actionConfiguration.title")}
            classic
        >
            <div className={css.pageActionConfiguration}>
                <ReactFlowProvider>
                    <ActionConfiguration />
                </ReactFlowProvider>
            </div>
        </FusionLayout>
    );
}
